import { dew as _getAddressDew } from "../address/getAddress.js";
import { dew as _isAddressEqualDew } from "../address/isAddressEqual.js";
import { dew as _recoverTypedDataAddressDew } from "./recoverTypedDataAddress.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.verifyTypedData = void 0;
  const getAddress_js_1 = _getAddressDew();
  const isAddressEqual_js_1 = _isAddressEqualDew();
  const recoverTypedDataAddress_js_1 = _recoverTypedDataAddressDew();
  async function verifyTypedData({
    address,
    domain,
    message,
    primaryType,
    signature,
    types
  }) {
    return (0, isAddressEqual_js_1.isAddressEqual)((0, getAddress_js_1.getAddress)(address), await (0, recoverTypedDataAddress_js_1.recoverTypedDataAddress)({
      domain,
      message,
      primaryType,
      signature,
      types
    }));
  }
  exports.verifyTypedData = verifyTypedData;
  //# sourceMappingURL=verifyTypedData.js.map
  return exports;
}